import gqlTagGira from 'graphql-tag';

export const NUMBER_FRAGMENT = gqlTagGira`
    fragment jiraNumberFieldFragment on JiraNumberField {
        number
        fieldConfig {
          isEditable
        }
    }
`;
